import { Component,  OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl, ValidatorFn, AbstractControl } from '@angular/forms';
import { AdvtService } from './../../_services/advt.service';
import { AlertService } from './../../_services';
import { Http } from '@angular/http';
import { MapsAPILoader } from '@agm/core';
import { environment } from './../../../environments/environment';

@Component({
  selector: 'app-help-info',
  templateUrl: './help-info.component.html',
  styleUrls: ['./help-info.component.css']
})
export class HelpInfoComponent implements OnInit {
 
  minLoader: any;
  mainLoader:any;
  loading:any;
  // Help Form Initialize 
  helpForm: FormGroup;

  constructor(private fb: FormBuilder, private advtService: AdvtService, private alertService: AlertService,private http: Http) {
  }
 
  ngOnInit() {
    this.minLoader = '../../assets/images/smallLoader.gif';
    this.mainLoader = '../../assets/images/BigLoader.gif';

    this.helpForm = this.fb.group({
      'message': ['', [Validators.required]]
    });

  }

  
  /**
   * 
   * @param  
   * Function to submit from data
   */
  onSubmit(event:any) {
    this.loading = true;
    
    this.advtService.askhelp(this.helpForm.value).subscribe(data => {
      
        if(data.status == 200){
          
          this.helpForm.reset({           
            'message': ''            
          });
          this.loading = false;
        this.alertService.success(data.message);
      }
      }, error => {
        this.loading = false;
        this.alertService.error(error);
      });
      
  }


   /**
  * function to Disable Space
  * @param event 
  */
 _checkSPace(event: any) {
  //this.durCheck = regexp.test(event.target.value)
  if (event.which === 32 && event.target.selectionStart === 0) {
    return false;
  }
}

}



// WEBPACK FOOTER //
// ./src/app/pages/help-info/help-info.component.ts